/**
 * Theme state.
 *
 *   themeChoiceAtom    — user-выбор `auto | light | dark` (persist).
 *   systemDarkAtom     — текущая системная тема (matchMedia).
 *   effectiveThemeAtom — derived: реальный `light | dark`. По нему
 *                        ThemeModeProvider вешает класс `.dark` на <html>.
 */

import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

export type ThemeMode = 'light' | 'dark';
export type ThemeChoice = 'auto' | ThemeMode;

const THEME_STORAGE_KEY = 'skrezo:theme:choice';

/**
 * Дарк-тема вшита (см. блок `.dark` в globals.css + ThemeModeProvider), но
 * пока ВЫКЛЮЧЕНА по решению: приложение светлое и НЕ следует системной теме,
 * т.к. дизайн-хендофф даёт только светлую палитру. Дефолт — `'light'`.
 *
 * Как включить, когда придёт дарк-палитра: поменять дефолт на `'auto'`
 * (следовать системе) и/или добавить переключатель темы через `useThemeChoice`.
 */
export const themeChoiceAtom = atomWithStorage<ThemeChoice>(THEME_STORAGE_KEY, 'light', undefined, {
  getOnInit: true,
});

export const systemDarkAtom = atom<boolean>(
  typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches,
);

export const effectiveThemeAtom = atom<ThemeMode>((get) => {
  const choice = get(themeChoiceAtom);
  if (choice === 'auto') return get(systemDarkAtom) ? 'dark' : 'light';
  return choice;
});
